import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, AvatarList, Button, clsx, Tooltip } from '@a-type/ui';
import { isHotseatPlayerId, isPrefixedId, SYSTEM_CHAT_AUTHOR_ID, } from '@long-game/common';
import { withGame } from '@long-game/game-client';
import { Link } from '@tanstack/react-router';
import cls from './PlayerAvatar.module.css';
import { PlayerInfo } from './PlayerInfo.js';
import { usePlayerThemed } from './usePlayerThemed.js';
const apiOrigin = import.meta.env.PUBLIC_API_ORIGIN || 'http://localhost:3101';
export const PlayerAvatar = withGame(function PlayerAvatar({ gameSuite, size, playerId, className, interactive, }) {
    const onlyPlayerId = playerId && isPrefixedId(playerId) ? playerId : undefined;
    const player = onlyPlayerId ? gameSuite.getPlayer(onlyPlayerId) : null;
    const { className: themeClass, style } = usePlayerThemed(onlyPlayerId);
    const status = onlyPlayerId
        ? (gameSuite.playerStatuses[onlyPlayerId] ?? null)
        : null;
    let imageUrl = null;
    if (playerId === SYSTEM_CHAT_AUTHOR_ID) {
        imageUrl = '/icon.png';
    }
    else if (playerId && isHotseatPlayerId(playerId)) {
        imageUrl = null;
    }
    else if (playerId) {
        const urlRaw = new URL(apiOrigin);
        urlRaw.pathname = `/users/${playerId}/avatar`;
        imageUrl = urlRaw.toString();
    }
    const content = (_jsx(Avatar, { name: playerId === SYSTEM_CHAT_AUTHOR_ID
            ? 'Game'
            : (player?.displayName ?? 'Anonymous'), imageSrc: imageUrl, style: {
            ...style,
            width: size ?? 24,
        }, "data-status": status?.online ? 'online' : 'offline', className: clsx(cls.avatar, themeClass, className), crossOrigin: "use-credentials" }));
    return (_jsx(Tooltip, { color: "neutral", content: !playerId ? ('Unknown player') : isPrefixedId(playerId) ? (_jsx(PlayerInfo, { playerId: playerId })) : ('The Rout app'), disabled: !playerId || gameSuite.gameStatus.status === 'pending', children: interactive ? (_jsx(Button, { size: "wrapper", emphasis: "ghost", render: playerId ? (_jsx(Link, { to: playerId && isPrefixedId(playerId)
                    ? `?playerId=${playerId}`
                    : '#' })) : undefined, nativeButton: false, children: content })) : (content) }));
});
export const PlayerAvatars = withGame(function PlayerAvatars({ gameSuite, className }) {
    return (_jsx(AvatarList, { className: className, count: gameSuite.members.length, children: gameSuite.members.map((member, index) => (_jsx(AvatarList.ItemRoot, { index: index, children: _jsx(PlayerAvatar, { playerId: member.id }) }, member.id))) }));
});
//# sourceMappingURL=PlayerAvatar.js.map